import Image from 'next/image';
import React from 'react';

const WhyGearFocus: React.FC = () => {
  return (
    <section className="py-[25px] md:py-[50px] px-10" id="why-gearfocus">
      <div className="max-w-[1306px] w-full mx-auto px-16 text-[18px] md:text-[24px]">
        <h1 className="font-semibold">
          Why GearFocus? Because We&apos;ve Been There.
        </h1>

        <div className="mt-12 font-medium flex flex-col gap-10">
          <p>
            Ever received camera gear that wasn&apos;t quite as advertised? <br />
            Ever needed cash quickly—and lost 40% or more of your gear&apos;s value by selling wholesale?
          </p>

          <strong className="font-semibold">
            We have. And we built GearFocus to make sure you never have to again.
          </strong>

          <strong className="font-semibold">
            What Makes GearFocus Different:
          </strong>

          <div className="w-full flex flex-col gap-5">
            <div className="flex items-center gap-5">
              <Image
                src="https://gearfocus.b-cdn.net/landings/orange-checkmark.png"
                alt="Checkmark"
                width={50}
                height={44}
                loading="lazy"
              />
              <div className="flex flex-col">
                <strong className="font-semibold">Verified Sellers Only.</strong>
                No more scams or questionable deals. Buy and sell with absolute confidence.
              </div>
            </div>

            <div className="flex items-center gap-5">
              <Image
                src="https://gearfocus.b-cdn.net/landings/orange-checkmark.png"
                alt="Checkmark"
                width={50}
                height={44}
                loading="lazy"
              />
              <div className="flex flex-col">
                <strong className="font-semibold">Free Listings, Always.</strong>
                Forget wholesaling your gear for pennies. Keep every dollar you deserve.
              </div>
            </div>

            <div className="flex items-center gap-5">
              <Image
                src="https://gearfocus.b-cdn.net/landings/orange-checkmark.png"
                alt="Checkmark"
                width={50}
                height={44}
                loading="lazy"
              />
              <div className="flex flex-col">
                <strong className="font-semibold">Risk-Free 48-Hour Verification.</strong>
                Gear arrives exactly as described—or you pay nothing.
              </div>
            </div>
          </div>

          <p>
            GearFocus isn&apos;t just another marketplace. It&apos;s the safe, reliable community photographers and filmmakers deserve.
          </p>

          <strong className="font-semibold">
            Stop choosing between convenience and fair value—now you can have both.
          </strong>
        </div>
      </div>
    </section>
  );
};

export default WhyGearFocus;
